import filtersState from './filters'

export default {
  filters: filtersState,
}
